import { NgFor } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-reasons',
    standalone: true,
    imports: [NgFor],
    templateUrl: './reasons.component.html',
    styleUrl: './reasons.component.less',
})
export class ReasonsComponent {
    reasons = [
        {
            reason: 'On Target',
            description: 'We utilize pre-defined scopes, optimally-aligned tech stacks, and a matured Agile development cycle to enable precise, goal-driven delivery.',
        },
        {
            reason: 'On Time',
            description: 'Our tightly-managed Scrum team follows a well monitored sprint cycle, supported by real-time dashboards, to guarantee timely achievement of milestones.',
        },
        {
            reason: 'On Budget',
            description: 'With a strategically scaled team and a highly disciplined workflow, we fulfill your requirements cost effectively, maximizing value within budget constraints.',
        },
        {
            reason: 'Organized well',
            description: 'Boasting a stable team with an average employee tenure exceeding 4 years, plus managers with over 20 years of industry experience, we ensure structured and reliable execution.',
        },
    ];
}
